<script setup>
defineProps({
  content: String,
  blok: Array,
})
</script>

<template>
  <div class="relative overflow-hidden">
    <div
      class="group/footer flow-root cursor-pointer rounded-md rounded-t-none bg-neutral-100 px-6 py-5"
    >
      <div class="relative z-10 flex flex-wrap items-center gap-2">
        <span class="z-10 mr-auto text-sm font-semibold text-primary">
          {{ content }}
        </span>
        <ul v-if="blok.length" class="m-0 h-[36px] min-w-[108px] p-0 [&>*]:h-full">
          <li v-for="action in blok" :key="action.uuid" class="mb-0">
            <StoryblokComponent :blok="action" :size="action.size" />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
